/**
 * Sessione docente chiusa/scaduta/inesistente: l'editor non deve restare bloccato.
 * `GET /sessions/by-pin/:pin` risponde 404 (not_found) o 410 (closed | expired, body
 * `{ error, reason }`): in questi casi l'app degrada a modalita' locale e mostra un avviso
 * NON bloccante. Qui vivono solo i testi e la lettura del `reason`, cosi' Scrivi e SVG Edit
 * dicono la stessa cosa.
 */

const SUFFISSO_LOCALE =
  'stai lavorando senza sessione, il lavoro non viene salvato nella sessione.';

/** True se lo status del by-pin indica una sessione mancante, chiusa o scaduta. */
export function isSessionGoneStatus(status: number): boolean {
  return status === 404 || status === 410;
}

/** Avviso per sessione mancante/chiusa/scaduta, scelto in base al `reason` del server. */
export function teacherSessionGoneNotice(reason?: string | null): string {
  if (reason === 'closed') return `La sessione collegata è chiusa: ${SUFFISSO_LOCALE}`;
  if (reason === 'expired') return `La sessione collegata è scaduta: ${SUFFISSO_LOCALE}`;
  if (reason === 'not_found') return `La sessione collegata non esiste più: ${SUFFISSO_LOCALE}`;
  return `La sessione collegata è chiusa o scaduta: ${SUFFISSO_LOCALE}`;
}

/** Avviso per errore di rete durante la verifica della sessione. */
export function teacherSessionNetworkNotice(): string {
  return `Errore di rete nel collegamento alla sessione: ${SUFFISSO_LOCALE}`;
}

/** Legge il `reason` dal body di una risposta 404/410 del by-pin (mai lancia). */
export async function readSessionGoneReason(res: Response): Promise<string | null> {
  try {
    const body = (await res.json()) as { reason?: unknown } | null;
    return typeof body?.reason === 'string' ? body.reason : null;
  } catch {
    return null;
  }
}
